import React, { useState, useEffect } from "react";
import Header from "./Header";
import { useLocation } from "react-router-dom";

import Subtract from "../img/Subtract.svg";
import Tick from "../img/tick.svg";
import RightAroowDark from "../img/RightAroowDark.svg";
import CallLog from "../img/CallLog.svg";
import AppFooter from "./AppFooter";
import api from "../../api/axiosInstance";
import AppHomeDetailsHeader from "./AppHomeDetailsHeader";
import AppDetailsHeader from "./AppDetailsHeader";
import HomeHeader from "./HomeHeader";
import { useNavigate, useParams } from "react-router-dom";

const AppDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, project_type } = location.state || {};
  const { projectName } = useParams();
  const [finalId, setFinalId] = useState(id || null);
  const [finalType, setFinalType] = useState(project_type || null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [appDetails, setAppDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  const [access, setAccess] = useState(localStorage.getItem("accessToken"));

  useEffect(() => {
    setAccess(localStorage.getItem("accessToken"));
  }, []);

  useEffect(() => {
    const fetchAppDetails = async () => {
      try {
        const response = await api.get(
          `/display/api/v1/display-project/${finalId}`
        );
        if (response.data?.status === "success") {
          console.log("API Response:", response.data.data);
          setAppDetails(response.data.data);
          setTimeout(() => {
            setLoading(false);
          }, 100);
        }
      } catch (error) {
        console.error("Error fetching app details:", error);
      }
    };

    if (finalId) {
      fetchAppDetails();
    }
  }, [finalId]); // use finalId instead of id

  useEffect(() => {
    const fetchProjectBySlug = async () => {
      if (!finalId && projectName) {
        const normalizedSearch = (projectName || "").replace(/-/g, "");
        try {
          const response = await api.get(
            `/display/api/v1/list-project-for-display?context=${encodeURIComponent(
              normalizedSearch
            )}`
          );
          if (
            response.data?.status === "success" &&
            response.data.data.results.length > 0
          ) {
            const project = response.data.data.results[0];
            setFinalId(project.id);
            setFinalType(project.project_type);
          }
        } catch (error) {
          console.error("Error fetching project by name:", error);
        }
      }
    };

    fetchProjectBySlug();
  }, [finalId, projectName]);

  const createSlug = (name) => {
    return name
      .toLowerCase()
      .replace(/[^\w\s]/gi, "") // Remove special characters
      .replace(/\s+/g, "-") // Replace spaces with hyphens
      .trim();
  };

  // In your navigation to AppPricing, update the onClick handlers:
  const goToAppPricing = () => {
    if (appDetails) {
      const projectSlug = createSlug(appDetails.name);
      navigate(`/AppPricing/${projectSlug}`, {
        state: {
          id: finalId,
          project_type: finalType,
          project: appDetails,
        },
      });
    }
  };

  if (loading || !appDetails) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="w-12 h-12 border-4 border-[#7D5AE3] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <div>
      {/* {access ? <AppDetailsHeader /> : <AppHomeDetailsHeader />} */}
      {access ? <Header /> : <HomeHeader />}

      <div className="flex flex-col w-full justify-center items-center bg-[#4C3A68] py-6">
        <div className=" max-w-5xl  flex flex-col items-center justify-center mb-6 px-6  text-white">
          <h1 className="text-3xl font-bold font-inter mt-2">
            {appDetails.name}
          </h1>

          <h1 className=" text-center text-xl font-inter mt-4">
            {appDetails.tagline} <br />
          </h1>
          <div className="flex justify-center items-center w-full sm:w-3/4">
            <p className=" text-center text-sm font-inter mt-4">
              {appDetails.description}
            </p>
          </div>

          <div className="flex sm:flex-row flex-col gap-2 sm:gap-5 justify-center items-center mt-6">
            {/* {id === 1 && (
              <button
                className="mt-2 w-48 rounded-full py-2 text-sm text-white bg-[#7D5AE3] rounded hover:bg-[#6c4ccc] transition"
                onClick={() =>
                  window.open("https://demo.onzitr.com/register", "_blank")
                }
              >
                Get Started with a Trial
              </button>
            )} */}

            <button
              onClick={goToAppPricing}
              className="mt-2 w-48 rounded-full py-2 text-sm text-white bg-[#7D5AE3] rounded hover:bg-[#6c4ccc] transition"
            >
              {/* inside your component's return */}
              {["DOPE Test", "NICE Analysis"].includes(appDetails?.name)
                ? "Start Your Personality Test"
                : "Get Started with a Plan"}

              {/* Get Started with a Plan */}
            </button>
          </div>
        </div>

        <div className="w-[90%] max-w-7xl mx-auto">
          <img
            src={appDetails.image}
            alt={appDetails.name}
            className="w-full object-cover rounded-lg"
          />
        </div>

        {/* Section Title */}
        <div className="w-[90%] text-center flex flex-col justify-center mt-10 font-extrabold text-left text-white font-inter text-3xl max-w-7xl mx-auto ">
          <h1 className="w-full">{appDetails.feature_title}</h1>
        </div>

        {/* Feature Grid */}
        <div className="w-[90%] max-w-7xl mx-auto mt-9">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 xl:gap-8">
            {appDetails.features.map((feature) => (
              <div
                key={feature.id}
                className="bg-white rounded-2xl flex flex-col p-5 shadow-md h-80"
              >
                {/* Icon */}
                <div className="mb-3">
                  <div className="w-12 h-12 rounded-full overflow-hidden">
                    <img
                      src={feature.logo}
                      alt={feature.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                {/* Title */}
                <h2 className="text-xl font-semibold text-[#4C3A68] mb-2">
                  {feature.name}
                </h2>

                {/* Description */}
                <p className="text-sm text-[#4C3A68]">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full flex justify-center items-center mt-10 mb-6 px-4">
          <div className="w-full sm:w-3/4 md:w-1/2 h-40 rounded-md flex flex-col items-center justify-center text-center">
            <div className="flex sm:flex-row flex-col gap-2 sm:gap-5 justify-center items-center mb-5">
              {/* {id === 1 && (
                <button
                  className="mt-2 w-48 rounded-full py-2 text-sm text-white bg-[#7D5AE3] rounded hover:bg-[#6c4ccc] transition"
                  onClick={() =>
                    window.open("https://demo.onzitr.com/register", "_blank")
                  }
                >
                  Get Started with a Trial
                </button>
              )} */}
              <button
                onClick={goToAppPricing}
                className="mt-2 w-48 rounded-full py-2  text-sm text-white bg-[#7D5AE3] rounded hover:bg-[#6c4ccc] transition"
              >
                {["DOPE Test", "NICE Analysis"].includes(appDetails?.name)
                  ? "Start Your Personality Test"
                  : "Get Started with a Plan"}
                {/* Get Started with a Plan */}
              </button>
            </div>
            <h1 className="text-2xl md:text-3xl font-inter font-extrabold text-white">
              Guarantee success for your business
            </h1>
            <p className="text-sm md:text-lg font-inter text-white mt-2">
              No credit card required. Instant product access.
            </p>
          </div>
        </div>
      </div>

      <AppFooter id={finalId} />
    </div>
  );
};

export default AppDetails;
